module.exports = __webpack_public_path__ + "static/media/basic-info-bg.36f0e5c6.jpg";